import { PRD3040_R01TabType } from '../Store_PRD3040_R01';

export const PRD3040_R01_TABS = [
    { id: 'date' as const, label: '일자별실적' },
    { id: 'item' as const, label: '품목별실적' },
    { id: 'workplace' as const, label: '공정별실적' },
];

const VIEW_TYPE_BY_TAB: Record<PRD3040_R01TabType, string> = {
    date: 'date',
    item: 'item',
    workplace: 'workplace',
};

const DISPLAY_NAME_BY_TAB: Record<PRD3040_R01TabType, string> = {
    date: '일자별실적',
    item: '품목별실적',
    workplace: '공정별실적',
};

export const getViewType = (tab: PRD3040_R01TabType): string => {
    return VIEW_TYPE_BY_TAB[tab] ?? VIEW_TYPE_BY_TAB.date;
};

export const getTabDisplayName = (tab: PRD3040_R01TabType): string => {
    return DISPLAY_NAME_BY_TAB[tab] ?? DISPLAY_NAME_BY_TAB.date;
};

export const getSubtotalRowId = (tabType: PRD3040_R01TabType, groupKey: string): string => {
    return `subtotal-${tabType}-${groupKey}`;
};

export const getDetailRowId = (tabType: PRD3040_R01TabType, row: any): string => {
    switch (tabType) {
        case 'date':
            return `${row?.compNm}-${row?.productDt}-${row?.workplaceNm}-${row?.itemCd}-${row?.productEmpNm}`;
        case 'item':
            return `${row?.compNm}-${row?.itemCd}-${row?.workplaceNm}-${row?.productDt}-${row?.productEmpNm}`;
        case 'workplace':
            return `${row?.compNm}-${row?.workplaceNm}-${row?.itemCd}-${row?.productDt}-${row?.productEmpNm}`;
        default:
            return row?.id ?? '';
    }
};

export const dedupeRowsByTab = <T extends Record<string, any>>(tabType: PRD3040_R01TabType, rows: T[]): T[] => {
    const seen = new Set<string>();
    const uniqueRows: T[] = [];

    for (const row of rows) {
        const rowId = getDetailRowId(tabType, row);
        if (!rowId || seen.has(rowId)) continue;
        seen.add(rowId);
        uniqueRows.push(row);
    }

    return uniqueRows;
};
